var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.21,
    height: 25.21,
    viewBox: "0 0 25.21 25.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.909,78.954a2.954,2.954,0,1,0-5.909,0V93.775a2.954,2.954,0,1,0,5.909,0Z",
    transform: "translate(-57.046 -72.258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M271,212h7.386v1.477H271Z",
    transform: "translate(-257.656 -201.561)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M185.69,121H171.484a4.395,4.395,0,0,1,.075.739v14.821a4.427,4.427,0,0,1-1.991,3.693H185.69a.738.738,0,0,0,.739-.739V121.739A.738.738,0,0,0,185.69,121ZM175.3,137.3a.739.739,0,1,1,.739-.739A.739.739,0,0,1,175.3,137.3Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,175.3,134.344Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,175.3,131.389Zm2.954,5.909a.739.739,0,1,1,.739-.739A.739.739,0,0,1,178.255,137.3Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,178.255,134.344Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,178.255,131.389Zm2.954,5.909a.739.739,0,1,1,.739-.739A.739.739,0,0,1,181.21,137.3Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,181.21,134.344Zm0-2.954a.739.739,0,1,1,.739-.739A.739.739,0,0,1,181.21,131.389Zm2.216-3.693a.738.738,0,0,1-.739.739h-8.863a.738.738,0,0,1-.739-.739v-2.954a.738.738,0,0,1,.739-.739h8.863a.738.738,0,0,1,.739.739Z",
    transform: "translate(-161.219 -115.042)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M250.6,0h-8.863A.738.738,0,0,0,241,.739V4.431h10.34V.739A.738.738,0,0,0,250.6,0Zm-2.954,2.954h-2.954a.739.739,0,0,1,0-1.477h2.954a.739.739,0,0,1,0,1.477Z",
    transform: "translate(-229.134)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.477,136.559V121.739A4.4,4.4,0,0,1,1.552,121H.739a.738.738,0,0,0-.739.739v17.775a.738.738,0,0,0,.739.739H3.468A4.427,4.427,0,0,1,1.477,136.559Z",
    transform: "translate(0 -115.042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFax);
export default __webpack_public_path__ + "static/media/fax.a0af9b9c94f3942973cdef677da031ae.svg";
export { ForwardRef as ReactComponent };